import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const benefits = [
  {
    icon: 'ri-speed-line',
    title: 'Obra rápida',
    description: 'Instalación en tiempo récord sin largas esperas. Sistema de construcción en seco que acelera los plazos.',
  },
  {
    icon: 'ri-brush-line',
    title: 'Acabados limpios',
    description: 'Superficies lisas listas para pintar. Mínima generación de escombros y polvo durante la obra.',
  },
  {
    icon: 'ri-volume-mute-line',
    title: 'Mejor acústica',
    description: 'Reduce el ruido entre estancias con sistemas de aislamiento acústico de alta eficiencia.',
  },
  {
    icon: 'ri-temp-cold-line',
    title: 'Aislamiento térmico',
    description: 'Ahorra en calefacción y aire acondicionado mejorando la eficiencia energética de tu hogar.',
  },
  {
    icon: 'ri-layout-grid-line',
    title: 'Redistribución flexible',
    description: 'Crea nuevos espacios o modifica los existentes sin obras complejas ni permisos especiales.',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Materiales de calidad',
    description: 'Utilizamos placas de pladur certificadas y perfilería de primera calidad para garantizar durabilidad.',
  },
];

const BenefitsSection = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  return (
    <section ref={ref} className="py-24 bg-dark-bg">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={inView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.6 }}
            className="inline-block px-4 py-2 bg-orange-primary/10 border border-orange-primary rounded-full mb-6"
          >
            <span className="text-orange-primary text-sm font-bold">Ventajas</span>
          </motion.div>
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            animate={inView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="text-4xl md:text-5xl font-extrabold text-text-primary mb-6"
          >
            Por qué elegir pladur
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={inView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.6, delay: 0.3 }}
            className="text-text-secondary text-lg max-w-2xl mx-auto"
          >
            <a href="https://pladures.es/barcelona/badalona/" target="_blank" rel="noopener noreferrer" className="text-orange-primary hover:underline">El pladur es la solución ideal para reformas modernas</a>, rápidas y eficientes
          </motion.p>
        </div>

        {/* Benefits Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, scale: 0.9 }}
              animate={inView ? { opacity: 1, scale: 1 } : {}}
              transition={{ duration: 0.5, delay: 0.1 * index }}
              className="bg-dark-card border border-dark-border rounded-xl p-8 hover:border-orange-primary transition-all duration-300"
            >
              <div className="w-14 h-14 bg-orange-primary/10 rounded-lg flex items-center justify-center mb-5">
                <i className={`${benefit.icon} text-orange-primary text-2xl`}></i>
              </div>
              <h3 className="text-xl font-bold text-text-primary mb-3">
                {benefit.title}
              </h3>
              <p className="text-text-muted text-[15px] leading-relaxed">
                {benefit.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;
